export enum GameGenderDBChoices {
  mixed = 'mi',
  females = 'fm',
  males = 'ma'
}

export enum GameGenderUIChoices {
  mixed = 'Mixed',
  females = 'Women only',
  males = 'Men only'
}

export const GameGenderSelectChoices = [
  {label: GameGenderUIChoices.mixed, value: GameGenderDBChoices.mixed},
  {label: GameGenderUIChoices.males, value: GameGenderDBChoices.males},
  {label: GameGenderUIChoices.females, value: GameGenderDBChoices.females},
];


